// extracted by mini-css-extract-plugin
module.exports = {"customMenu":"Menu_customMenu__3Nn6o","navbarHidden":"Menu_navbarHidden__KHmjp"};